import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";

export default function NotFound() {
  return (
    <Layout>
      <div className="text-center py-20">
        <div className="text-6xl font-bold text-[var(--ks-primary)]" data-testid="notfound-code">404</div>
        <p className="mt-3 text-[var(--ks-text-soft)]">The page you're looking for doesn't exist on Etherscan.</p>
        <Link to="/" className="ks-link inline-block mt-6">← Back to Home</Link>
      </div>
    </Layout>
  );
}
